




















































































import Vue, { PropType } from 'vue';
import { mapActions } from 'vuex';

import { IInventoryAdvancePayment, IUser } from '@/models';
import { setErrorFromAxiosError } from '@/utils/helpers';
import { ISystemError } from '@/models/error/error.types';

import InventoryAdvancePaymentFinanceManagerPicker from './common/InventoryAdvancePaymentFinanceManagerPicker.vue';

export default Vue.extend({
  name: 'InventoryAdvancePaymentFinanceManagerListMenu',

  components: { InventoryAdvancePaymentFinanceManagerPicker },

  props: {
    inventoryAdvancePayment: {
      type: Object as PropType<IInventoryAdvancePayment>,
      required: true
    },
    disabled: Boolean
  },

  data() {
    return {
      financeManagerLoading: false,
      financeManagerDialog: false,
      error: null as ISystemError | null,
      financeManager: null as null | number
    };
  },

  watch: {
    financeManagerDialog(value: boolean) {
      if (value) {
        if (this.inventoryAdvancePayment.finance_manager) {
          this.financeManager =
            (this.inventoryAdvancePayment.finance_manager as IUser).id ??
            (this.inventoryAdvancePayment.finance_manager as number);
        }
        this.clearErrors();
      }
    }
  },

  methods: {
    ...mapActions({
      assignInventoryAdvancePaymentFinanceManager:
        'inventoryAdvancePayment/assignInventoryAdvancePaymentFinanceManager'
    }),

    closeDialog() {
      this.financeManagerDialog = false;
    },

    clearErrors() {
      this.error = null;
    },

    setInventoryAdvancePaymentFinanceManager(financeManager: number) {
      this.clearErrors();
      this.financeManagerLoading = true;
      this.assignInventoryAdvancePaymentFinanceManager({
        inventoryAdvancePaymentId: this.inventoryAdvancePayment.id,
        financeManager
      })
        .then(() => {
          this.closeDialog();
        })
        .catch(error => {
          this.error = setErrorFromAxiosError(error);
        })
        .finally(() => {
          this.financeManagerLoading = false;
        });
    }
  }
});
